import {createSlice} from '@reduxjs/toolkit'
import {Keys} from "../../common/constants";

const initialState = {
    value: 'en'
}
export const languageLocalStoreKey = Keys.LANGUAGE
export const languageReducer = createSlice({
    name: 'language',
    initialState,
    reducers: {
        getLanguageFromStore: (): any => {
            const language = localStorage.getItem(languageLocalStoreKey);

            return language || initialState.value;
        },
        setLanguage: (state, action) => {
            state.value = action.payload
        }
    }
})

// Action creators are generated for each case reducer function
export const {
    setLanguage,
    getLanguageFromStore
} = languageReducer.actions

export default languageReducer.reducer
